import React from 'react'
import Membersbox from './Membersbox'

import pimage5 from '../images/s5.png'
import pimage4 from '../images/s4.png'
import pimage3 from '../images/s3.png'
import pimage2 from '../images/s2.png'
import pimage1 from '../images/s1.png'

export default function Members() {
    return (
        <div>

      
      
           <div className="title">
      <br></br>
      <br></br>
      <br></br>
            <h2>Team Members</h2>
    </div>
        
        <div id= 'maindish'>

        <div className='a-container'>
        <Membersbox image={pimage5} title="Alexander Vissani"/> 
        <Membersbox image={pimage4} title="Ali Abbas Zaidi"/> 
        <Membersbox image={pimage3} title="Nicolas Moncada"/> 
        <Membersbox image={pimage2} title="Ahemd Dawoud"/>
        <Membersbox image={pimage1} title="Yida Li"/>
        </div>



        </div>
        </div>
    )
}
